module.exports = __webpack_public_path__ + "images/e8bbb534.pay_3_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_3_kor.png
// module id = 496
// module chunks = 0